export class BaseImage {
  image_url: string;
  order: number;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  isBeforeReviewing(): boolean {
    return false;
  }

  getImageUrl(): string {
    return this.image_url;
  }
}

export class Image extends BaseImage {
  id: number;
  user_id: number;
  image_url: string;
  status: string;
  face_weight: number;
  disclose: string;
  is_mosaic: boolean;
  aasm_state: string;

  constructor(fields: any) {
    super(fields);
  }

  isBeforeReviewing(): boolean {
    return this.aasm_state === "before_reviewing";
  }
}



// WEBPACK FOOTER //
// ./src/models/image.ts